import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Info } from "lucide-react";

interface HowItWorksModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  apr: number;
}

export function HowItWorksModal({ open, onOpenChange, apr }: HowItWorksModalProps) {
  const formatAPR = (value: number) => value.toFixed(1);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Info className="w-5 h-5 text-accent" />
            How It Works
          </DialogTitle>
          <DialogDescription>Understanding early payment discount calculations</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 text-sm text-muted-foreground">
          <p>
            When you upload an invoice, we automatically calculate an early payment discount based
            on your APR and Early Payment Minimum, then send an offer to your supplier.
          </p>
          <div className="space-y-2 p-4 bg-muted/50 rounded-lg">
            <p className="font-medium text-foreground">Example calculation:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Invoice amount: $10,000</li>
              <li>Due date: 30 days from now</li>
              <li>Early payment minimum: 5 days from now (25 days early)</li>
              <li>APR rate: {formatAPR(apr)}%</li>
              <li>
                Discount: $10,000 × {formatAPR(apr)}% × (25 / 365) ={" "}
                <strong>${((10000 * (apr / 100) * 25) / 365).toFixed(2)}</strong>
              </li>
            </ul>
          </div>
          <p>
            The supplier receives an email with the early payment offer. If they accept, you pay the
            discounted amount within 5 business days. If they decline, you pay the full amount on
            the original due date.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
